/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromptToolCall
 */
export interface PromptToolCall {
    /**
     * 
     * @type {string}
     * @memberof PromptToolCall
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptToolCall
     */
    tool_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromptToolCall
     */
    is_mutation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromptToolCall
     */
    is_success?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PromptToolCall
     */
    duration_ms?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PromptToolCall
     */
    input?: { [key: string]: any; };
}

/**
 * Check if a given object implements the PromptToolCall interface.
 */
export function instanceOfPromptToolCall(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tool_name" in value;
    isInstance = isInstance && "is_mutation" in value;

    return isInstance;
}

export function PromptToolCallFromJSON(json: any): PromptToolCall {
    return PromptToolCallFromJSONTyped(json, false);
}

export function PromptToolCallFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptToolCall {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tool_name': json['tool_name'],
        'is_mutation': json['is_mutation'],
        'is_success': !exists(json, 'is_success') ? undefined : json['is_success'],
        'duration_ms': !exists(json, 'duration_ms') ? undefined : json['duration_ms'],
        'input': !exists(json, 'input') ? undefined : json['input'],
    };
}

export function PromptToolCallToJSON(value?: PromptToolCall | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tool_name': value.tool_name,
        'is_mutation': value.is_mutation,
        'is_success': value.is_success,
        'duration_ms': value.duration_ms,
        'input': value.input,
    };
}

